// extracted by mini-css-extract-plugin
export default {"submenu":"main-menu-mobile_submenu__IerCV"};